module.exports = __webpack_public_path__ + "img/clockBlack.a772a7e7.svg";